// Voamada — Système i18n minimaliste
// Pas de lib externe : context React + dictionnaires plats fr/mg.
// Usage:  const { t } = useI18n(); t("nav.home")

import React, { createContext, useContext, useEffect, useState } from "react";
import frDict from "./locales/fr.json";
import mgDict from "./locales/mg.json";

const DICTS = { fr: frDict, mg: mgDict };
const SUPPORTED = ["fr", "mg"];
const STORAGE_KEY = "voamada_lang";

const I18nContext = createContext({ lang: "fr", setLang: () => {}, t: (k) => k });

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const saved = (typeof window !== "undefined") ? localStorage.getItem(STORAGE_KEY) : null;
    return saved && SUPPORTED.includes(saved) ? saved : "fr";
  });

  const setLang = (next) => {
    if (!SUPPORTED.includes(next)) return;
    setLangState(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch { /* ignore */ }
    try { document.documentElement.setAttribute("lang", next); } catch { /* ignore */ }
  };

  useEffect(() => { try { document.documentElement.setAttribute("lang", lang); } catch { /* ignore */ } }, [lang]);

  const t = (key, fallback) => {
    const dict = DICTS[lang] || DICTS.fr;
    if (dict[key]) return dict[key];
    if (DICTS.fr[key]) return DICTS.fr[key];
    return fallback ?? key;
  };

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
